import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate, CanMatch,
  GuardResult,
  MaybeAsync, Route,
  Router,
  RouterStateSnapshot, UrlSegment
} from "@angular/router";
import {AuthService} from "../auth/services/auth.service";
import { Roles } from '../constants/roles';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanMatch{

  adminUrls: string[] = ['/dashboard'];
  constructor(private authService: AuthService,
              private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    const roles = this.authService.getRoleFromSessionStorage();
    if (roles) {
      return roles.includes(Roles.ADMIN) || roles.includes(Roles.USER);
    }
    return false;
  }

  canMatch(route: Route, segments: UrlSegment[]): MaybeAsync<GuardResult> {
    const roles = this.authService.getRoleFromSessionStorage();
    if (roles?.includes(Roles.ADMIN)){
      return true;
    }
    if (segments.some(segment => this.adminUrls.includes(segment.path))) {
      this.router.navigateByUrl('/home');
    }
    return true;
  }
}
